import ApplyService from "@/service/ApplyService"
import AccountService from "@/service/AccountService"
import AddressService from "@/service/AddressService"
import HelpService from "@/service/HelpService"
import LogService from "@/service/LogService"
import SessionService from "@/service/SessionService"
import TestService from "@/service/TestService"
import WorkflowService from "@/service/WorkflowService"
import ValidationService from "@/service/ValidationService"
import ProveService from "@/service/ProveService"
import IovationService from "@/service/IovationService"

export const applyService = ApplyService
export const accountService = AccountService
export const addressService = AddressService
export const helpService = HelpService
export const logService = LogService
export const workflowService = WorkflowService
export const sessionService = new SessionService()
export const testService = TestService
export const validationService = ValidationService
export const proveService = ProveService
export const iovationService = new IovationService()
